export const META_CONSENT_STORAGE_PREFIX = 'ms_meta_consent:';
export const META_POLICY_VERSION = '1';

export type MetaConsentDecision = 'accepted' | 'rejected';

export type MetaConsentState = {
  decision: MetaConsentDecision;
  timestamp: string;
  policyVersion: string;
};

export type MetaPixelConfig = {
  pixelId?: string;
  enabled?: boolean;
  inheritFromParish?: boolean;
};

export type EffectiveMetaPixel = {
  pixelId: string;
  enabled: true;
};

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}
